// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  chatUsageId: __t.u64().primaryKey().name("chat_usage_id"),
  orgId: __t.u64().name("org_id"),
  model: __t.string(),
  inputTokens: __t.u32().name("input_tokens"),
  outputTokens: __t.u32().name("output_tokens"),
  costUsdMicros: __t.i64().name("cost_usd_micros"),
  createdAt: __t.i64().name("created_at"),
});
